import dayjs from "dayjs";

// All live data for the Sequoia ETF comes from these PHP feeds (fund ID 6604 is set on the page).
// Each script reads the fund from $_POST['fundID'], so every call is a POST with that one field.
export const FEED_BASE = "https://filepoint.live/sequoia/";

export function feedParams(fundID) {
    return { fundID: fundID };
}

export function feedUrl(name) {
    return FEED_BASE + name + ".php";
}

// Fetches one feed and resolves with its payload (never rejects; null when
// there is no usable data, so every section simply keeps its "--" placeholders).
// The feeds wrap their payload as {cached, data, error}; a bare array is accepted too.
export function fetchFeed(name, fundID) {
    return new Promise((resolve) => {
        $.ajax({
            type: "post",
            url: feedUrl(name),
            data: feedParams(fundID),
            dataType: "json",
            success: (res) => resolve(unwrap(res, name)),
            error: (xhr, status, err) => {
                console.warn("[feed] " + name + " request failed:", status, err || "");
                resolve(null);
            },
        });
    });
}

function unwrap(res, name) {
    if (res == null) return null;
    if (Array.isArray(res)) return res.length ? res : null;
    if (typeof res === "object") {
        if ("data" in res) {
            if (res.error) console.warn("[feed] " + name + " reported:", res.error);
            return unwrap(res.data, name);
        }
        return Object.keys(res).length ? res : null;
    }
    return null;
}

// Normalises a payload to a flat list of row objects: an array as-is, an object
// holding arrays (e.g. {fund:[...], index:[...]}) flattened, a single record wrapped.
export function toRows(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data.filter((r) => r && typeof r === "object");
    if (typeof data === "object") {
        const nested = Object.keys(data).map((k) => data[k]).filter(Array.isArray);
        return nested.length ? [].concat(...nested) : [data];
    }
    return [];
}

// First non-empty value among candidate keys (case-insensitive on the key).
export function pick(row, keys) {
    if (!row) return null;
    const lower = {};
    Object.keys(row).forEach((k) => (lower[k.toLowerCase()] = k));
    for (const key of keys) {
        const real = key in row ? key : lower[key.toLowerCase()];
        if (real !== undefined && row[real] != null && row[real] !== "") return row[real];
    }
    return null;
}

export function num(v) {
    if (v == null) return null;
    const n = typeof v === "string" ? parseFloat(v.replace(/[,%$\s]/g, "")) : Number(v);
    return Number.isFinite(n) ? n : null;
}

export function pct(v, digits = 2) {
    const n = num(v);
    return n == null ? null : n.toFixed(digits) + "%";
}

export function money(v) {
    const n = num(v);
    if (n == null) return null;
    const abs = Math.abs(n);
    if (abs >= 1e9) return "$" + (n / 1e9).toFixed(2) + "B";
    if (abs >= 1e6) return "$" + (n / 1e6).toFixed(1) + "M";
    return "$" + Math.round(n).toLocaleString("en-US");
}

export function fmtDate(v, fmt = "MMMM D, YYYY") {
    if (v == null) return null;
    const d = dayjs(v);
    return d.isValid() ? d.format(fmt) : null;
}

// Only writes when there is a value, so placeholders survive missing data.
export function setText(selector, value) {
    if (value != null) $(selector).html(value);
}

export function indexNameOf(row) {
    return pick(row, ["indexName", "benchmarkName", "benchmark", "index"]);
}

export function isIndexRow(row) {
    return indexNameOf(row) != null;
}

// The fund's own record: first row that is not a benchmark row.
export function fundRow(rows) {
    return rows.find((r) => !isIndexRow(r)) || null;
}

// The benchmark row whose name contains `name` (from data-index-name), else the first benchmark row.
export function indexRow(rows, name) {
    const idx = rows.filter(isIndexRow);
    if (!idx.length) return null;
    const needle = String(name || "").toLowerCase().replace(/\s+/g, "");
    return idx.find((r) => String(indexNameOf(r)).toLowerCase().replace(/\s+/g, "").indexOf(needle) > -1) || idx[0];
}

export function pageIndexName() {
    return $(".fundid").data("index-name") || "S&P 500";
}
